import moment from 'moment-timezone';

export const FormatDateYMD = (date: Date): string => {
  return moment(date).tz('America/Sao_Paulo').format('YYYY-MM-DD');
}

export const FormatDateYMD_UTC_IGNORE = (date: Date): string => {
   return moment(date).utc(false).format('YYYY-MM-DD')
}

export const DateToStringDate = (date: Date): string => {
  //return moment(date).utc(true).format('DD/MM/YYYY')
  return moment(date).format('DD/MM/YYYY')
}

/** Formata datas sem horário (ex.: vencimento de boleto) sem deslocamento de timezone. */
export const DateOnlyToStringDate = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  return moment.utc(date).format('DD/MM/YYYY');
}

export const BrDateToDate = (date: Date): Date => {
  const brDate = moment(date, ['DD/MM/YYYY'], true);
  if(brDate.isValid()) {
    const day = moment(date, 'DD/MM/YYYY HH:mm:ss').set({hour: 12}).format('YYYY-MM-DD HH:mm:ss')
    return new Date(day)
  }
  return new Date(date);
}

export const DateToStringDateTime = (date: Date): string => {
  //return moment(date).utc(true).format('DD/MM/YYYY HH:mm')
  return moment(date).format('DD/MM/YYYY HH:mm')
}

export const DateToStringTime = (date: Date): string => {
  //return moment(date).utc(true).format('HH:mm:ss')
  return moment(date).format('HH:mm:ss')
}

export const addMonthToDate = (date: Date | string, months: number): Date => {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + parseInt(`${months}`))
  return newDate;
}

export const subtractMonthToDate = (date: Date | string, months: number): Date => {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() - parseInt(`${months}`))
  return newDate;
}

export const getNewZeroDay = (date: Date | string): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}
